import React from 'react'
import CardPicker from 'src/card_picker/CardPicker'
import { CampaignFragment } from 'src/graphql'
import { useActions, useMutations } from 'src/hooks'
import { AddCampaignCardRoute } from '../../routes/AddCampaignCardRoute'
import { CampaignRoute } from 'src/campaigns/routes/CampaignRoute'
import { EditCampaignCardRoute } from 'src/campaigns/routes/EditCampaignCardRoute'
import { ReplaceCampaignCardRoute } from 'src/campaigns/routes/ReplaceCampaignCardRoute'
import { buildInput } from '../../utils'

export interface CardActionsProps {
  editableCampaign: CampaignFragment
  campaignRoute: CampaignRoute
  route: AddCampaignCardRoute | EditCampaignCardRoute | ReplaceCampaignCardRoute
  resetRoute: () => void
}

const AddCampaignCard: React.FC<CardActionsProps> = props => {
  const { editableCampaign, campaignRoute, resetRoute } = props
  const { route } = props as { route: AddCampaignCardRoute }

  const actions = useActions()
  const mutations = useMutations()

  const handleAdd = async (cardId: string) => {
    const campaignInput = buildInput(editableCampaign)
    await mutations.updateCampaign({
      campaign: {
        ...campaignInput,
        lines: (campaignInput.lines || []).concat([
          {
            card: cardId,
            giftVariation: undefined,
            sendDelay: null,
          },
        ]),
      },
    })
    resetRoute()
  }

  return (
    <CardPicker
      onAfterSave={handleAdd}
      context={{
        headerText: `Campaign: ${editableCampaign.name}`,
        headerSubText: `Adding card #${editableCampaign.lines.length + 1}`,
        lines: editableCampaign.lines,
        footerLabel: () => (
          <b>
            {editableCampaign.lines.length} card
            {editableCampaign.lines.length > 1 && 's'}
          </b>
        ),
      }}
      catalogSubroute={route.subroute}
      saveButtonLabel="Add to campaign"
      onClose={resetRoute}
      onCatalogNavigate={subroute =>
        actions.openCampaigns(
          CampaignRoute(
            campaignRoute.campaignId,
            AddCampaignCardRoute(subroute),
          ),
        )
      }
    />
  )
}

export default AddCampaignCard
